import request from '@/utils/request'
// const PREFIX = '/fmis/fmis'
const PREFIX = '/fmis'
// 夜审-自动查询
export function isJumpWindowRemind(params) {
  return request({
    url: `${PREFIX}/nightAudit/isJumpWindowRemind`,
    method: 'get',
    params
  })
}
// 查询酒店并发夜审
export function checkNightAudit(params) {
  return request({
    url: `/system/hotel/night/trial/concurrent`,
    method: 'get',
    params
  })
}
// 手动触发夜审
export function handTriggerNightAudit(params) {
  return request({
    url: `/system/hotel/night/trial`,
    method: 'get',
    params
  })
}
// 获取夜审日志列表
export function fetchNightAuditLog(params) {
  return request({
    url: `/system/hotel/night/trial/log`,
    method: 'get',
    params
  })
}
// 下载夜审日志
export function downloadNightAuditLog(params) {
  return request({
    url: `/system/hotel/night/trial/export/txt`,
    method: 'get',
    params
  })
}
// 查询夜审明细
export function getNightAuditDetail(params) {
  return request({
    url: `/system/hotel/night/trial/detail/log`,
    method: 'get',
    params
  })
}
// 查询酒店灰度夜审列表
export function fetchGrayHotelist(params) {
  return request({
    url: `/system/hotel/night/trial/graylevel`,
    method: 'get',
    params
  })
}
